import { Form, Formik, FormikHelpers } from "formik"
import { PageTitle } from "../../../_metronic/layout/core"
import { inventoryAddSchema } from "../../schemas/inventory"
import { FormBody } from "../../components/form/FormBody"
import { FormInputDate, FormInputFile } from "../../components/form/FormInputs"
import { useEffect, useState } from "react"
import { FormFooterBase } from "../../components/form/FormFooters"
import { CreateInventoryType } from "../../models/inventory"
import { getPresignedURL } from "../../api/presignedURL"
import { uploadWithPresignedUrl } from "../../libs/function"
import { useNavigate } from "react-router-dom"
import { UseAddInventoryBatch } from "../../hooks/inventory"
import { useAppContext } from "../../../_metronic/helpers/AppContext"

const AddInventoryPage = () => { 
  const [selectedFile, setSelectedFile] = useState<File | null>(null)
  const [isUploading, setIsUploading] = useState<boolean>(false)
  const {mutate: addInventoryBatch} = UseAddInventoryBatch()
  const { role } = useAppContext();
  const navigate = useNavigate();
  const formInitValue = {
    production_date: '',
    file_url: ''
  }
  const [isFormComplete, setIsFormComplete] = useState<boolean>(false);
  const [formValue, setFormValue] = useState<CreateInventoryType>(formInitValue);

  useEffect(() => {
    if(formValue.production_date !== '' && formValue.file_url !== '' && selectedFile !== null) {
      setIsFormComplete(true);
    } else {
      setIsFormComplete(false);
    }
  },[formValue , selectedFile])
  

  const onSubmit = async(values: CreateInventoryType , action: FormikHelpers<CreateInventoryType>) => {
    setIsUploading(true);
    const rootFolder = process.env.REACT_APP_AWS_S3_FOLDER;
    const fileExtension = selectedFile ? selectedFile.name.split('.').pop()?.toLowerCase() : 'xlsx';
        const fileName = `${rootFolder}/import_logs/inventory/Upload.${fileExtension}`;
        const presignedURL = await getPresignedURL(fileName);
        const url = presignedURL.data.split('.com')[0] + '.com';
        await uploadWithPresignedUrl(selectedFile, presignedURL.data );
        const fileUrl = (`${url}/${fileName}`);
        delete values.file;
        const mappedValues = {
            ...values,
            file_url: fileUrl
        };
        addInventoryBatch({ data : mappedValues });
        setIsUploading(false);
        action.resetForm();
        navigate('/inventory');
  }
  
  const mode = process.env.REACT_APP_ENVIRONMENT;
  if (role !== 1 || mode === "production") {
      return (
        <>
        </>
      )
    }

  return (
    <>
      <PageTitle breadcrumbs={[{
      title: 'TSM',
      path: '/inventory',
      description:'Tambah Perangkat',
      isActive: true,
      isSeparator: false
      }]}>Inventory</PageTitle>

      <div className="card mb-5 mx-xl-10">
        <Formik
          initialValues={formInitValue}
          validationSchema={inventoryAddSchema} 
          onSubmit={onSubmit}
        >
          <Form>
            <FormBody>
              <h2 className="fs-3 fw-bold text-gray-800 mb-3">Tambah Perangkat</h2>
              <hr className="mb-6  text-gray-400" />
              <FormInputDate labelName="Tanggal Produksi" name="production_date" value={''} required onValueChange={(e) => {setFormValue({...formValue, production_date: e as string })}} />
              <FormInputFile name="file_url" labelName="File" meta={{ error: 'File', touched: false }} typeInput="add-inventory" onValueChange={(e) =>{
                 setSelectedFile(e);
                 setFormValue({...formValue, file_url: e  ? e.name : ''})
              }}/>
            </FormBody>
            <FormFooterBase linkTo={"/inventory"} confirmText={isUploading ? 'Loading...' : 'Simpan'} isloading={isUploading} confirmDisable={!isFormComplete}/>
          </Form>
        </Formik>

      </div>
    </>
    
  )
}

export default AddInventoryPage